/**
 * The `payment.*` capabilities (CAPABILITIES.md §3.4): taking money for an order, through the
 * payment engine (N18). Ids from the cart contract (P0 step 12); policies in C1, hidden until then.
 */
import { definePolicies } from "../engine";
import type { OrderResource } from "./order";

declare module "../types" {
  interface CapabilityMap {
    "payment.checkout": OrderResource;
    "payment.quickSettle": OrderResource;
    /** the call centre's Pay: take payment, then place the order Open (§9.3) */
    "payment.payAndPlace": OrderResource;
  }
}

export const PAYMENT_POLICIES = definePolicies("payment", []);
